import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { DealmakerDetail } from "../../../Services/DealmakerCatalog";
import { logoUrl } from "../dealmakerDisplay";

interface DealmakerOverviewProps {
  deal: DealmakerDetail;
}

export default function DealmakerOverview({ deal }: DealmakerOverviewProps): ReactElement {
  return (
    <section>
      <h2 className="dealmaker-heading">Overview</h2>
      <div className="dealmaker-toolbar">
        <div className="dealmaker-tabs">
          <span className="dealmaker-tab-active">Overview</span>
          <Link to={`/dealmaker?action=info&dealid=${deal.dealId}`}>Contact Firm</Link>
        </div>
        {deal.logoName ? <img className="dealmaker-detail-logo" src={logoUrl(deal.logoName)} alt="" /> : null}
      </div>
      <p className="dealmaker-title">{deal.title}</p>
      <p>{deal.description}</p>
      <p><span className="dealmaker-label">Deal Location</span>: {deal.location}</p>
      <p><span className="dealmaker-label">Deal Region</span>: {deal.regionName}</p>
      <p><span className="dealmaker-label">Deal Type</span>: {deal.dealType}</p>
      <p><span className="dealmaker-label">Deal Value</span>: {deal.dealValue}</p>
      <p><span className="dealmaker-label">Industry</span>: {deal.industries}</p>
      <p><span className="dealmaker-label">Governing Law</span>: {deal.governingLaw}</p>
      {deal.additionalInfo ? (
        <div>
          <p className="dealmaker-label">Additional Information:</p>
          <p>{deal.additionalInfo}</p>
        </div>
      ) : null}
    </section>
  );
}
